<template>
  <div class="questionnaires">
    <vimeo-player
      class="player"
      :video-id="videoContentId"
      player-width="100%"
      player-height="100%"
      ref="vue"
      @ended="exec($event, eventType.ENDED)"
      @pause="exec($event, eventType.PAUSE)"
      @fullscreenchange="exec($event, eventType.FULLSCREEN_CHANGE)"
      @timeupdate="exec($event, eventType.TIME_UPDATE)"
    />

    <div class="playerMessage" v-if="isFinishedLive">
      <div class="playerMessage_content playerMessage_content-error">
        <p>以上で、LIVE配信は終了です。<br />ご視聴頂きありがとうございました。</p>
      </div>
    </div>

    <Questionnaires
      :disable-start-button-questionnaire-ids="disableStartButtonQuestionnaireIds"
      :is-live="isLive"
      :questionnaires="questionnaires"
      :slug="slug"
      @updateQuestionnaire="updateQuestionnaire"
    />
  </div>
</template>

<script>
import Questionnaires from "./Questionnaires/Questionnaires"
import QuestionnaireEntity from "../../../../common/js/entity/questionnaireEntity"
import PlayerEvent from "../../entity/playerEvent"
import EventType from "../../../../common/js/enum/player/event-type"

export default {
  name: "VimeoManager",
  components: {Questionnaires},
  props: {
    videoContentId: {
      type: String,
      required: true
    },
    isLive: {
      type: Boolean,
      required: false,
      default: false
    },
    playVideo: {
      type: Boolean,
      required: true
    },
    questionnaireSettings: {
      type: Array,
      required: true
    },
    disableStartButtonQuestionnaireIds: {
      type: Array,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    startAt: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      eventType: EventType,
      questionnaires: [],
      events: [],
      isFinishedLive: false
    }
  },
  computed: {
    player: function() {
      return this.$refs.vue
    }
  },
  watch: {
    playVideo: function(newValue) {
      if (newValue) {
        this.player.play()
      }
    }
  },
  created() {
    this.setQuestionnaires()
    this.setEvents()
  },
  mounted() {
    this.player.pause()
  },
  methods: {
    setQuestionnaires() {
      const questionnaires = _.groupBy(this.questionnaireSettings, "questionnaire_id")

      this.questionnaires = _.map(questionnaires, (settings, questionnaireId) => {
        return new QuestionnaireEntity(questionnaireId, settings, this.isLive, this.startAt)
      })
    },
    setEvents() {
      this.events = []
      this.events.push(this.liveCheckEvent())
      this.events.push(this.enableTimeupdateEvent())

      this.questionnaires.forEach(questionnaire => {
        this.events = this.events.concat(questionnaire.events)
      })
    },
    updateQuestionnaire(newQuestionnaire) {
      this.questionnaires = this.questionnaires.filter(questionnaire => {
        return questionnaire.id !== newQuestionnaire.id
      })

      this.questionnaires = this.questionnaires.push(newQuestionnaire)
    },
    isLiveNow(data) {
      // safari以外、 Infinity で判定
      if (data.duration === Infinity) return true

      // safariのみ、 47721.859 で判定
      return data.duration === 47721.859
    },
    liveCheckEvent() {
      const event = new PlayerEvent(this.eventType.TIME_UPDATE)

      event.setCallback(data => {
        if (!this.isLive) return

        if (this.isLiveNow(data)) return

        this.player.pause()
        this.player.player.setCurrentTime(0)

        this.isFinishedLive = true
      })

      return event
    },
    enableTimeupdateEvent() {
      const event = new PlayerEvent(EventType.TIME_UPDATE)

      event.setCallback(data => {
        this.events
          .filter(event => {
            return event.type === EventType.TIME_UPDATE && !event.enabled
          })
          .forEach(event => {
            if (this.isLive && this.isLiveNow(data)) return

            if (data.seconds > event.data.seconds) return

            event.enabled = true
          })
      })

      return event
    },
    exec(data, type) {
      this.events
        .filter(event => {
          return event.type === type
        })
        .forEach(event => {
          if (event.enabled && typeof event.callback === "function") {
            event.callback.call(this, data, this.player)
          }
        })
    }
  }
}
</script>
